import { render, staticRenderFns } from "./GreetingWidget.vue?vue&type=template&id=2f7691e7&scoped=true&"
import script from "./GreetingWidget.vue?vue&type=script&lang=js&"
export * from "./GreetingWidget.vue?vue&type=script&lang=js&"
import style0 from "./GreetingWidget.vue?vue&type=style&index=0&id=2f7691e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7691e7",
  null
  
)

export default component.exports